import type { ModulatorLinkCsId, ModulatorLinkHwId } from "~domain/devices/models/links/link-model.ts";

import { z } from "zod";

export const backofficeFindLinksResponseSchema = z
  .object({
    csId: z.number().transform((s) => s as ModulatorLinkCsId),
    csLinkToCutId: z
      .number()
      .transform((s) => s as ModulatorLinkCsId)
      .nullable(),
    cutLink: z.boolean(),
    hwId: z.number().transform((s) => s as ModulatorLinkHwId),
    interfaceName: z.string().nullable(),
    isGlobal: z.boolean(),
    isUpdated: z.boolean(),
    measureIndex: z.number(),
    measureType: z.number(),
    numInterface: z.number(),
  })
  .array();

export type BackofficeFindLinksResponse = z.infer<typeof backofficeFindLinksResponseSchema>;
